"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemsServices = exports.menuItemsPlantsNursery = exports.menuItemsOccurrences = exports.menuItemsFarm = exports.menuItemsAttendanceRecords = exports.menuItemsApplications = exports.menuAdmin = void 0;
var menuItemsFarm = exports.menuItemsFarm = function menuItemsFarm(state) {
  return state.menu.farm;
};
var menuItemsServices = exports.menuItemsServices = function menuItemsServices(state) {
  return state.menu.services;
};
var menuItemsOccurrences = exports.menuItemsOccurrences = function menuItemsOccurrences(state) {
  return state.menu.occurrences;
};
var menuItemsAttendanceRecords = exports.menuItemsAttendanceRecords = function menuItemsAttendanceRecords(state) {
  return state.menu.attendanceRecords;
};
var menuItemsPlantsNursery = exports.menuItemsPlantsNursery = function menuItemsPlantsNursery(state) {
  return state.menu.plantsNursery;
};
var menuItemsApplications = exports.menuItemsApplications = function menuItemsApplications(state) {
  return state.menu.applications;
};
var menuAdmin = exports.menuAdmin = function menuAdmin(state) {
  return state.menu.admin;
};